<template lang="html">
  <form role="form" v-on:submit.prevent.stop>
    <template v-if="model.options.isTemporarilyDisabled">
      <payout-hint-panel-form-group v-bind:warning="true" v-bind:heading="$t('warning_temp_blocked_title')">
        <template>{{$t('warning_temp_blocked_text')}}</template>
      </payout-hint-panel-form-group>
      <br>
    </template>


    <template v-if="model.options?.isFullnameRequired">
      <EpayInputFormGroup :label="$t('ФИО (опционально)')" attribute="fio"
                          :hint="$t('fio_hint')"
                          :placeholder="$t('fio_placeholder')"
                          :model="model"
                          :required="!model.options?.isFullnameRequiredButOptional" />
    </template>

    <payout-form-group v-bind:label="$t('Номер карты')" v-bind:required="true" v-bind:has-errors="model.errors.has('cardNumber')">
      <filtered-input-wrapper v-model="model.values.cardNumber">
        <payout-cardnumber-input v-model="model.values.cardNumber"></payout-cardnumber-input>
      </filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints v-bind:hint="$t('card_number_hint')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="cardNumber|*" v-bind:errors="model.errors"></error-message-block>
    </payout-form-group>

    <payout-textfield-input-group v-bind:model="model" v-bind:label="$t('Назначение')" v-bind:required="true" attribute="description">
    </payout-textfield-input-group>

    <payout-input-amount-form-group v-bind:model="model"></payout-input-amount-form-group>
    <payout-evaluate-fee-form-group v-bind:model="model"></payout-evaluate-fee-form-group>

    <!-- Будет применен курс автоконвертации ({src} = {dest}) -->
    <!-- <payout-destination-currency-conversion-notice-form-group v-bind:model="model"></payout-destination-currency-conversion-notice-form-group> -->
    <!-- Ожидаемая сумма зачисления -->
    <payout-estimated-destination-amount-form-group v-bind:model="model"></payout-estimated-destination-amount-form-group>

    <template v-if="model.options.limitsTextHtml">
      <payout-toggable-hint-panel-form-group v-bind:heading="$t('Лимиты')" v-bind:link-text="$t('Информация о лимитах')">
        <div v-html="model.options.limitsTextHtml"></div>
      </payout-toggable-hint-panel-form-group>
    </template>

    <PayoutHintPanelFormGroup :warning="true">
      <i18n path="rucards_2card2card_text_0" tag="p" class="warning--text--underlined">
      </i18n>

      <i18n path="rucards_2card2card_text_1" tag="p">
        <template v-slot:card2card>
          <a href="/finance/payout/rucards" :title="$t('channel_name')">{{$t('channel_name')}}</a>
        </template>
      </i18n>
    </PayoutHintPanelFormGroup>

    <payout-form-notification-block v-bind:model="model"></payout-form-notification-block>

    <hr>

    <payout-group-verification-type v-bind:model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {defineComponent, reactive} from "vue";
import {Card2cardPaymentModel} from "@/components/forms/payout/forms/cards/cards-payments";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutCardnumberInput from "@/components/forms/payout/forms/PayoutCardnumberInput.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import EpayInputFormGroup from "@/components/forms/payout/forms/epay/EpayInputFormGroup.vue";


export default defineComponent({
  name: "Card2cardPaymentForm",
  components: {
    EpayInputFormGroup,
    PayoutFormGroup, PayoutHintPanelFormGroup,
    FilteredInputWrapper, PayoutGroupVerificationType,
    PayoutFormNotificationBlock, PayoutToggableHintPanelFormGroup,
    PayoutInputAmountFormGroup, ErrorMessageBlock,
    PayoutTextfieldInputGroup, PayoutEstimatedDestinationAmountFormGroup,
    PayoutEvaluateFeeFormGroup, PayoutCardnumberInput, PayoutInputHintBlock
  },
  extends: AbstractPayoutForm,
  setup() {
    const model = reactive(new Card2cardPaymentModel());
    return {
      model
    }
  }
})
</script>

<!--<script lang="ts" setup>-->


<!--// const model = reactive(new Card2cardPaymentModel()) as Card2cardPaymentModel;-->

<!--//import {defineComponent} from "vue";-->
<!--// import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";-->


<!--</script>-->

<style scoped>

</style>


<i18n>
{
  "ru": {
    "warning_temp_blocked_title": "Временно недоступно",
    "warning_temp_blocked_text": "Данный вид платежей временно недоступен в связи с техническими сложностями.",
    "warning_dynamic_fee": "Тариф динамичный. Пожалуйста, обращайте внимание на размер комиссии в момент подтверждения операции.",
    "card_number_hint": "Номер карты получателя. Пример: 1234 5678 9012 3456",
    "fio_hint": "Имя Фамилия Отчество. Заполнение данного поля не является обязательным, но может заметно ускорить конверсию и время обработки транзакций.",
    "fio_placeholder": "Иван Иванов Иванович",
    "rucards_2card2card_text_0": "Для сокращения количества отмененных транзакций провайдерами были скорректированы настройки.",

    "rucards_2card2card_text_1": "Часть платежей, совершенных через данный канал, в случае невозможности их обработки, может быть исполнена через {card2card} (не с карты физического лица).",
    "rucards_2card2card_text_2": "В качестве дополнительной меры советуем совершать платежи суммами до {amount} рублей. При необходимости по несколько транзакций одномоментно.",
    "channel_name": "канал OCT"
  },
  "en": {
    "fio_placeholder": "Ivan Ivanov Ivanovich",
    "ФИО (опционально)": "Full name (optional)",
    "fio_hint": "Name Surname Patronymic. Filling in this field is not mandatory, but can significantly speed up conversion and transaction processing time.",
    "Назначение": "Description",
    "warning_temp_blocked_title": "Temporarily unavailable",
    "warning_temp_blocked_text": "This payment type is temporarily unavailable due to technical difficulties.",
    "warning_dynamic_fee": "The tariff is dynamic. Please pay attention to the commission size at the time of confirming the operation.",
    "card_number_hint": "Recipient card number. Example: 1234 5678 9012 3456",
    "Номер карты": "Card number",
    "Лимиты": "Limits",
    "Информация о лимитах": "Information about limits",
    "rucards_2card2card_text_0": "To reduce the number of transactions canceled by providers, the settings have been adjusted.",
    "rucards_2card2card_text_1": "Part of the payments made through this channel, in case of impossibility of their processing, can be executed through {card2card} (not from card to card).",
    "rucards_2card2card_text_2": "As an additional measure, we recommend making payments in amounts up to {amount} rubles. If necessary, several transactions at the same time.",
    "channel_name": "OCT channel"
  }
}
</i18n>
